import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'

const CardBillingSummaryArUX = (props: any) => {
    return(
      <div
        id="CardBillingSummaryArUX-div-0"
        style={{}}>
        <div
          id="CardBillingSummaryArUX-div-24"
          style={{fontWeight: "bold", fontSize: "1.2rem",padding: "10px 10px 0px 10px", display: "flex", justifyContent: "space-between"}}>
          {props.languageUX === "en" ? "Shift Closing Summary" : "สรุปยอดปิดกะ"}
          <div
            id="CardBillingSummaryArUX-div-72">
            
          </div>
        </div>
        <div
          id="CardBillingSummaryArUX-div-87"
          style={{ padding: "0px 10px 5px 10px"}}>
          
          <hr
            id="CardBillingSummaryArUX-hr-88">
          </hr>
        </div>
        <div
          id="CardBillingSummaryArUX-div-95"
          style={{ padding: "0px 10px"}}>
          {props.errorMessage}
        </div>
        <div
          id="CardBillingSummaryArUX-div-93"
          style={{ padding: "5px 10px 0px 10px"}}>
          
          <Table
            data={props.billingSummaryData}
            headers={props.languageUX === "en" ? "Date-Time, Document No,Status,Cash,Bank Transfer,Cheque" : "วันที่ - เวลา,เลขที่เอกสาร,สถานะ,เงินสด,เงินโอน,เช็ค"}
            id="tb-billingSummaryData"
            keys="created_at_dt,code_formatted,status_label,sum_payment_cash_price,sum_payment_transfer_price,sum_payment_cheque_price"
            minRows={1}
            showPagination={false}
            style={{height: "450px",  zoom: "87%", margin: "0px 10px"}}>
          </Table>
        </div>
        <div
          id="CardBillingSummaryArUX-div-89"
          style={{display: "flex", justifyContent: "flex-end", margin: "10px"}}>
          
          <div
            id="CardBillingSummaryArUX-div-90">
            {props.buttonRefresh}
          </div>
          <div
            id="btn-printShiftReport"
            style={{ margin: "0px 10px" }}>
            {props.buttonPrint}
          </div>
          <div
            id="btn-closeShiftReport">
            {props.buttonSave}
          </div>
        </div>
        <div
          id="CardBillingSummaryArUX-div-65"
          style={{width: "100%", height: "200px"}}>
          
        </div>
      </div>
    )
}


export default CardBillingSummaryArUX

export const screenPropsDefault = {"debug":true,"language":"EN","showSupplyList":false}

/* Date Time : Fri Oct 31 2025 04:20:17 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingSummaryArUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "สรุปยอดปิดกะ",
          "valueEN": "Shift Closing Summary"
        },
        "id": {
          "type": "value",
          "value": "CardBillingSummaryArUX-div-24"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", fontSize: \"1.2rem\",padding: \"10px 10px 0px 10px\", display: \"flex\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingSummaryArUX-div-65"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height: \"200px\"}"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 24,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingSummaryArUX-div-72"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingSummaryArUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0px 10px 5px 10px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "hr",
      "parent": 87,
      "props": {
        "id": {
          "type": "value",
          "value": "CardBillingSummaryArUX-hr-88"
        }
      },
      "seq": 88,
      "void": true
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingSummaryArUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\", margin: \"10px\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonRefresh"
        },
        "id": {
          "type": "value",
          "value": "CardBillingSummaryArUX-div-90"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonPrint"
        },
        "id": {
          "type": "value",
          "value": "btn-printShiftReport"
        },
        "style": {
          "type": "code",
          "value": "{ margin: \"0px 10px\" }"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 89,
      "props": {
        "children": {
          "type": "code",
          "value": "props.buttonSave"
        },
        "id": {
          "type": "value",
          "value": "btn-closeShiftReport"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardBillingSummaryArUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"5px 10px 0px 10px\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 94,
      "name": "Table",
      "parent": 93,
      "props": {
        "data": {
          "type": "code",
          "value": "props.billingSummaryData"
        },
        "headers": {
          "type": "value",
          "value": "วันที่ - เวลา,เลขที่เอกสาร,สถานะ,เงินสด,เงินโอน,เช็ค",
          "valueEN": "Date-Time, Document No,Status,Cash,Bank Transfer,Cheque"
        },
        "id": {
          "type": "value",
          "value": "tb-billingSummaryData"
        },
        "keys": {
          "type": "value",
          "value": "created_at_dt,code_formatted,status_label,sum_payment_cash_price,sum_payment_transfer_price,sum_payment_cheque_price"
        },
        "minRows": {
          "type": "code",
          "value": "1"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{height: \"450px\",  zoom: \"87%\", margin: \"0px 10px\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.errorMessage"
        },
        "id": {
          "type": "value",
          "value": "CardBillingSummaryArUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{ padding: \"0px 10px\"}"
        }
      },
      "seq": 89,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardBillingSummaryArUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "debug": true,
    "language": "EN",
    "showSupplyList": false
  },
  "width": 80
}

*********************************************************************************** */
